export enum Routes {
  users = "users",
  userDetails = "user_details",
  userCreate = "user_create",
  roles = "roles",
  roleDetails = "role_details",
  roleCreate = "role_create",
  merchants = "merchants_list",
  merchantDetails = "merchant_details",
  merchantPurchaseDetails = "merchant_Purchase_details",
  login = "login",
  purchases = "pending_purchases",
  offers = "offers",
  coupons = "coupons",
  offersCreateAndDetails = "offers_create_and_details",
  packages = "packages",
  packageDetails = "package_details",
  countries = "countriesList",
  purchaseCreate = "purchase_create",
  enterprisePurchaseCreate = "enterprise_purchase_create",
  products = "products",
  productsDetails = "product/products_details",
  addEditProduct = "product/add_edit_product",
  discoverCollectionList = "collection_list",
  discoverSectionList = "section_list",
  mazeed = "mazeed",
  mazeedCustomers = "mazeed/mazeed_customers",
  mazeedCustomerDetails = "mazeed/mazeed_customer_details",
  themes = "themeList",
  storeSettings = "/officers/settings/stores/{storeId}/settings",
  discover = "mazeed/mazeed_discover",
  generatedInvoice = "/resellers/settlements/{settlementId}/invoice",
  zidWallet = "zid_wallet",
  walletVerificationDetails = "zid_wallet/verification_requests/:id",
  forbidden = "/403",
  sms = "sms",
  campaignSenders = "campaign_senders",
  dashboard = "meta_dashboard",
  wallet = "zid_wallet",
  tools = "tools",
  log = "log",
  merchantOrderDetails = "merchant_order_details",
  marketplace = "marketplace",
  latestFeatures = "latest_features",
  contracts = "contracts",
  paymentLinks = "payment_links",
  paymentLinksCreate = "payment_links_create",
  paymentLinksDetails = "payment_links_details",
  oneTimeOffersList = "one_time_offers_list",
  oneTimeOffersEdit = "one_time_offers_edit",
  couponsV2 = "coupons_v2",
  couponsV2Create = "coupons_v2_create",
  couponsV2Details = "coupons_v2_details",
}
